import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useCallback, useEffect } from 'react';
import { useIsMobile, useLocalStorage } from '@tmapy/beetlejuice-utils';
import { SvgCaretRight, SvgTiles, TertiaryBtn } from '@tmapy/style-guide';
import { MapSwitcherItem } from './MapSwitcherItem';
import './MapSwitcher.scss';
export const MapSwitcher = ({ appId, mapSwitcher, layers, dispatch, isAnotherPanelVisible, mobileBeakpoint, }) => {
    const [isCollapsed, setCollapsed] = useLocalStorage(`${appId}.MapSwitcher.isCollapsed`);
    const isCollapsedBool = isCollapsed === 'true';
    const isMobileQuery = useIsMobile(mobileBeakpoint ?? 0);
    const isMobile = mobileBeakpoint ? isMobileQuery : false;
    const icon = isCollapsedBool ? _jsx(SvgTiles, {}) : _jsx(SvgCaretRight, {});
    useEffect(() => {
        if (isAnotherPanelVisible && isMobile) {
            setCollapsed('true');
        }
    }, [isAnotherPanelVisible, isMobile, setCollapsed]);
    const handleCollapseBtnClick = useCallback(() => {
        setCollapsed(!isCollapsed ? 'true' : null);
    }, [isCollapsed, setCollapsed]);
    if (mapSwitcher.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: classNames('msw-container', {
            'msw-container-isCollapsed': isCollapsedBool,
        }), children: [mapSwitcher.length > 1 && (_jsx(TertiaryBtn, { unsafeClassName: 'msw-container--collapseBtn', icon: { element: icon }, onClick: handleCollapseBtnClick })), _jsx("div", { className: 'sg-a-d-f sg-a-cg-1', children: mapSwitcher.map((layer) => (_jsx(MapSwitcherItem, { layer: layer, layers: layers, dispatch: dispatch }, layer.layerId))) })] }));
};
//# sourceMappingURL=MapSwitcher.js.map